import { Observable } from "rxjs/Observable";
import { forkJoin } from "rxjs/observable/forkJoin";
import { of } from "rxjs/observable/of";
import { _throw } from "rxjs/observable/throw";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { ApiObjectFacade } from "../api-object/api-object.facade";
import { AccountApiFacade } from "./account.api-facade";
import { Account } from "./account.model";
import { AccountStoreFacade } from "./account.store-facade";

export class AccountFacade extends ApiObjectFacade<Account, AccountApiFacade, AccountStoreFacade> {

    /**
     * Syncing account is a bit of a special case because the CGET on /accounts does not output the full object
     * like it does for other entities. So we need to go and get each one individually.
     */
    syncEach(options?: ApiRequestOptions): Observable<any> {
        return forkJoin(this.getAll(options).take(1), this.store.getAll().take(1))
            .do(args => {
                let remote: Array<Account>;
                let local: Array<Account>;
                [remote, local] = args;
                this.updateStore(remote, local, options);
            })
            .catch(error => this.handleSyncError(error));
    }

    syncOne(id: string, options?: ApiRequestOptions): Observable<any> {
        if (this.appFacade.objects.isChangePending(id)) {
            return of(undefined);
        }

        return this.api.get(id, options)
            .catch(error => {
                if (error.status === 404) {
                    this.store.get(id)
                        .take(1)
                        .do(item => {
                            this.store.remove(item, {persistable: true, restful: false});
                        })
                        .subscribe(item => undefined);
                    return of(undefined);
                } else {
                    return _throw(error);
                }
            })
            .do(object => this.insertIfFresher(object));
    }

    private getAll(options?: ApiRequestOptions): Observable<Array<Account>> {
        return this.api.getAll(options)
            .concatMap(accounts => {

                if (!accounts.length) {
                    return of([]);
                } else if (accounts.length === 1) {
                    return this.api.get(accounts[0].id)
                        .map(account => [account]);
                }

                return forkJoin(...accounts.map(account => this.api.get(account.id)));
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.facade.ts